import axios from 'axios'

const METRIC_RESPONSE_KEYS = {
  views: 'daily_views',
  earnings: 'daily_earnings',
}

function normalizeBoostPeriods(periods = []) {
  return periods.map(period => ({
    startDate: period.start_date,
    endDate: period.end_date,
  }))
}

export async function fetchItemPerformance(itemId, metricType) {
  if (!itemId) throw new Error('Item ID is required')
  if (!metricType) throw new Error('Metric type is required')

  const response = await axios.get(`/api/internal/items/${itemId}/performance`, {
    params: { metric_type: metricType },
  })

  const attributes = response?.data?.data?.attributes || {}
  const metricKey = METRIC_RESPONSE_KEYS[metricType] || METRIC_RESPONSE_KEYS.views

  return {
    series: attributes[metricKey] || {},
    boostPeriods: normalizeBoostPeriods(attributes.boost_periods),
  }
}
